import { render, staticRenderFns } from "./UnifiedIntegration.vue?vue&type=template&id=27025630&scoped=true"
import script from "./UnifiedIntegration.vue?vue&type=script&lang=js"
export * from "./UnifiedIntegration.vue?vue&type=script&lang=js"
import style0 from "./UnifiedIntegration.vue?vue&type=style&index=0&id=27025630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27025630",
  null
  
)

export default component.exports